import React from 'react';
import i18n from 'i18n';
import questionsvg from 'assets/img/question.svg';
import Button from 'react-bootstrap/Button';

interface LeaveProps {
  onClose: any;
  goToPrevious: () => void;
}

const Leave = (props: LeaveProps) => {
  return (
    <div className="text-center">
      <div style={{ height: '80px' }} />
      <h1>{i18n.t('wizard:details.leave.title')}</h1>
      <br />

      <img src={questionsvg} alt={'question'} />
      <div style={{ height: '60px' }} />
      <p>{i18n.t('wizard:details.leave.message')}</p>
      <br />

      <Button variant="secondary" onClick={props.goToPrevious}>
        {i18n.t('wizard:details.leave.noStay')}
      </Button>
      <Button className={'ml-3'} variant="primary" onClick={props.onClose}>
        {i18n.t('wizard:details.leave.leave')}
      </Button>
    </div>
  );
};

export default Leave;
